import {getStatusValue} from '../../helpers';

export function columns() {
  return [{
    id: 1, title: 'Name', field: 'name', filter: '', filterLabel: 'Filter By Name'
  }, {
    id: 2, title: 'Domain', field: 'domain_name', filter: '', filterLabel: 'Filter By Domain Name'
  }, {
    id: 3, title: 'Hosted By', field: 'hosted_by', filter: '', filterLabel: 'Filter By Hosted', filterMinWidth: 120
  }, {
    id: 4, title: 'Status', filter: 'all', filterType: 'select', filterMinWidth: 80,
    getValue: rowData => getStatusValue(rowData.status), options: [{label: 'All', value: 'all'}, {label: 'OK', value: 'OK'}, {label: 'NOK', value: 'NOK'}, {label: 'OFFLINE', value: 'OFFLINE'}]
  }, {
    id: 5, title: 'Last Heartbeat', field: 'heartbeat', filter: '', filterLabel: 'Filter By Heartbeat', filterMinWidth: 136, isDate: true
  }];
}